/*  ==========================================================================
    GENERAL
    Collection of general utilities.
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import enquire from 'enquire.js';

// local imports
import * as vars from '../../globals/variables';

/*
 * DEV TOOLS ADVERTISING
 */

export function initDevToolsAdv () {
    $(window).on('load', function () {

        // output only if body has not the class 'be-user'
        if (!$(vars.$body).hasClass('be-user')) {
            let consoleLogo = `%c 
bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb
bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb
bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb
bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb
bbbbbbbbbbb    bbbbbbbbbbbbbbbbb
bbbbbbbbbbb    bbbbbbbbbbbbbbbbb
bbbbbbbbbbb    bbbbbbbbbbbbbbbbb
bbbbbbbbbbb    bbbbbbbbbbbbbbbbb
bbbbbbbbbbb    bbbbbbbbbbbbbbbbb
bbbbbbbbbbb    bbbbbbbbbbbbbbbbb
bbbbbbbbbbb         bbbbbbbbbbbb
bbbbbbbbbbb          bbbbbbbbbbb
bbbbbbbbbbb          bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb    bbb   bbbbbbbbbbb
bbbbbbbbbbb          bbbbbbbbbbb
bbbbbbbbbbb          bbbbbbbbbbb
bbbbbbbbbbb    bb   bbbbbbbbbbbb
bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb
bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb
bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb
bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb
            `,
            consoleText = '%cYou like tech? We like it too! Join our team: https://www.brandnamic.com/';
            console.log(consoleLogo, 'font: 16px/10px monospace');
            console.log(consoleText, 'font: 10px');
        }

    });
}

/*
 * RESOLUTION INFOS (needs "enquire.js")
 */

export function initResolutionInfo () {

    // full screen vista is possible or not
    enquire.register('only screen and (min-height: 700px) and (min-width: 1025px)', {
        match : function() {
            vars.$body.addClass('full-screen-on');
        },
        unmatch : function() {
            vars.$body.removeClass('full-screen-on');
        }
    });
    enquire.register('only screen and (max-height: 699px) and (min-width: 1025px)', {
        match : function() {
            vars.$body.addClass('full-screen-off');
        },
        unmatch : function() {
            vars.$body.removeClass('full-screen-off');
        }
    });

    // mobile or non mobile
    enquire.register('only screen and (min-width: 1025px)', {
        match : function() {
            vars.$body.addClass('non-mobile-view');
        },
        unmatch : function() {
            vars.$body.removeClass('non-mobile-view');
        }
    });
    enquire.register('only screen and (max-width: 1024px)', {
        match : function() {
            vars.$body.addClass('mobile-view');
        },
        unmatch : function() {
            vars.$body.removeClass('mobile-view');
        }
    });

    // desktop large
    enquire.register('only screen and (min-width: 1921px)', {
        match: function () {
            vars.$body.addClass('desktop-view-large');
        },
        unmatch: function () {
            vars.$body.removeClass('desktop-view-large');
        }
    });

    // desktop medium
    enquire.register('only screen and (min-width: 1601px) and (max-width: 1920px)', {
        match: function () {
            vars.$body.addClass('desktop-view-medium');
        },
        unmatch: function () {
            vars.$body.removeClass('desktop-view-medium');
        }
    });

    // desktop small
    enquire.register('only screen and (min-width: 1367px) and (max-width: 1600px)', {
        match: function () {
            vars.$body.addClass('desktop-view-small');
        },
        unmatch: function () {
            vars.$body.removeClass('desktop-view-small');
        }
    });

    // laptop
    enquire.register('only screen and (min-width: 1025px) and (max-width: 1366px)', {
        match: function () {
            vars.$body.addClass('laptop-view');
        },
        unmatch: function () {
            vars.$body.removeClass('laptop-view');
        }
    });

    // tablet
    enquire.register('only screen and (min-width: 769px) and (max-width: 1024px)', {
        match: function () {
            vars.$body.addClass('tablet-view');
        },
        unmatch: function () {
            vars.$body.removeClass('tablet-view');
        }
    });

    // phablet
    enquire.register('only screen and (min-width: 481px) and (max-width: 768px)', {
        match: function () {
            vars.$body.addClass('phablet-view');
        },
        unmatch: function () {
            vars.$body.removeClass('phablet-view');
        }
    });

    // phone
    enquire.register('only screen and (max-width: 480px)', {
        match: function () {
            vars.$body.addClass('phone-view');
        },
        unmatch: function () {
            vars.$body.removeClass('phone-view');
        }
    });

}

/*
 * HEADER OFFSET
 */

export function initHeaderOffset () {
    let headerOffset = 0;

    // reset header heights before calculation
    vars.$p_header.removeClass('bn-header--minimized');
    vars.$p_mobileHeader.removeClass('bn-mobile-header--minimized');

    // check which header is visible (default or mobile)
    if (vars.$body.hasClass('non-mobile-view')) {
        headerOffset = vars.$p_header.outerHeight();
    } else {
        headerOffset = vars.$p_mobileHeader.outerHeight();
    }

    return headerOffset;
}

/*
 * REMOVE SPECIFIC PARAMETERS
 */

export function initRemoveParam(key, sourceURL) {
    let rtn = sourceURL.split('?')[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';
    if (queryString !== '') {
        params_arr = queryString.split('&');
        for (let i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split('=')[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        rtn = rtn + '?' + params_arr.join('&');
    }
    return rtn;
}

/*
 * RESPONSIVE VIDEO SOURCES (needs "enquire.js")
 * based on: https://css-tricks.com/video-source-by-screen-size/
 */

export function initRespVideoSrc(container) {
    $(container).find('video').each(function () {
        let $video = $(this),
            hdSrc = $video.data('hd-src'),
            hdType = $video.data('hd-type'),
            phoneSrc = $video.data('phone-src'),
            phoneType = $video.data('phone-type'),
            tabletSrc = $video.data('tablet-src'),
            tabletType = $video.data('tablet-type');

        // hd
        enquire.register('only screen and (min-width: 1025px)', {
            match : function() {
                if (!$video.hasClass('bn-video-local--ready')) {
                    $video.append('<source type="' + hdType + '" src="' + hdSrc + '" />');
                    $video.addClass('bn-video-local--ready');
                }
            }
        });

        // tablet
        enquire.register('only screen and (min-width: 769px) and (max-width: 1024px)', {
            match: function () {
                if (!$video.hasClass('bn-video-local--ready')) {
                    if (tabletSrc) {
                        $video.append('<source type="' + tabletType + '" src="' + tabletSrc + '" />');
                    } else {
                        $video.append('<source type="' + hdType + '" src="' + hdSrc + '" />');
                    }
                    $video.addClass('bn-video-local--ready');
                }
            }
        });

        // phone
        enquire.register('only screen and (max-width: 768px)', {
            match: function () {
                if (!$video.hasClass('bn-video-local--ready')) {
                    if (phoneSrc) {
                        $video.append('<source type="' + phoneType + '" src="' + phoneSrc + '" />');
                    } else {
                        if (tabletSrc) {
                            $video.append('<source type="' + tabletType + '" src="' + tabletSrc + '" />');
                        } else {
                            $video.append('<source type="' + hdType + '" src="' + hdSrc + '" />');
                        }
                    }
                    $video.addClass('bn-video-local--ready');
                }
            }
        });

    });
}

// get-params as object
export function getAllUrlParams(url) {
    // get query string from url (optional) or window
    let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    let obj = {};

    // if query string exists
    if (queryString) {

        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        let arr = queryString.split('&');

        for (let i=0; i<arr.length; i++) {
            // separate the keys and the values
            let a = arr[i].split('=');

            // in case params look like: list[]=thing1&list[]=thing2
            let paramNum = undefined;
            let paramName = a[0].replace(/\[\d*\]/, function(v) {
                paramNum = v.slice(1,-1);
                return '';
            });

            // set parameter value (use 'true' if empty)
            let paramValue = typeof(a[1])==='undefined' ? true : a[1];

            // if parameter name already exists
            if (obj[paramName]) {
                // convert value to array (if still string)
                if (typeof obj[paramName] === 'string') {
                    obj[paramName] = [obj[paramName]];
                }
                // if no array index number specified...
                if (typeof paramNum === 'undefined') {
                    // put the value on the end of the array
                    obj[paramName].push(paramValue);
                }
                // if array index number specified...
                else {
                    // put the value at that index number
                    obj[paramName][paramNum] = paramValue;
                }
            }
            // if param name doesn't exist yet, set it
            else {
                obj[paramName] = paramValue;
            }
        }
    }

    return obj;
}

// cookies

export function setCookie(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    if(typeof cvalue === 'object') {
        cvalue = JSON.stringify(cvalue);
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
export function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return false;
}
export function updateMerkliste() {
    let merkliste = $('#merkliste'),
        listencounter = merkliste.find('.counter'),
        cookie_name = 'bn-wishlist';

    let wishlist = Cookies.getJSON(cookie_name);

    if (wishlist) {
        if (Object.keys(wishlist).length == 0) {
            merkliste.addClass('no_items');
            listencounter.html('0');
        } else {
            merkliste.removeClass('no_items');
            listencounter.html(Object.keys(wishlist).length);
        }
    } else {
        merkliste.addClass('no_items');
        listencounter.html('0');
    }
}


// WEBPACK FOOTER //
// ./source/js/utilities/lib/general.js